import { makeStyles } from '@mui/styles';
import React, { memo } from 'react';
import Button from '../../../Button';

const useStyles = makeStyles(({ typography }) => ({
  button: {
    marginRight: typography.pxToRem(20),
    letterSpacing: '-0.02em',
  },
}));

const TransferActionButtons = ({ config }) => {
  const classes = useStyles();
  return (
    <>
      {Object.entries(config).map(([btnKey, btnConfig]) => (
        <Button
          key={btnKey}
          data-test-id={btnKey}
          variant="contained"
          disabled={btnConfig.isDisabled}
          bgColor={btnConfig.color.bg}
          opacityDisabled={0.38}
          className={classes.button}
          border={btnConfig.color.border}
          onClick={btnConfig.onClick}
          color={btnConfig.color.text}
        >
          {btnConfig.title}
        </Button>
      ))}
    </>
  );
};

export default memo(TransferActionButtons);
